import * as React from 'react';
import {
  SpaceBetween,
  Button,
  ListItem,
  SheetContentWrapper,
  SheetContent,
  SheetPortal,
  Sheet, SheetHeader, SheetClose, SheetOverlay, space, tok,
} from '@sunwebgroup/ui-components';
import {styled} from 'styled-components';
import {useIntl} from '@/intl';
import { FilterableCarsAvailable } from '@/scopes/checkout/components/services/CarRentalFilteringService/FilterableCars/FilterableCarsAvailable';
import { useService } from '@/scopes/checkout/domain/hooks';
import { ServiceType } from '@/scopes/checkout/domain/types';
import {
  carToBeSelected,
  showingExtraCars,
  useCarRentalServiceStore,
} from '@/scopes/checkout/components/services/CarRentalFilteringService/store';

export function ExtraCarsView({ maxNumbersOfCarsToBeBooked }: { maxNumbersOfCarsToBeBooked: number; }) {
  const intl = useIntl();
  const { service } = useService(ServiceType.CarRentalFiltering);
  const { setShowExtraCars } = useCarRentalServiceStore();
  const isShowingExtraCars = useCarRentalServiceStore(showingExtraCars);
  const selectingCar = useCarRentalServiceStore(carToBeSelected);

  if (maxNumbersOfCarsToBeBooked <= 1) return null;
  if (!service) return null;
  const { options } = service;
  const selectingCarOption = selectingCar ? options?.[selectingCar] : null;

  return (
    <SpaceBetween direction="y" spacing={space('primitives_space_12')}>
      {!selectingCarOption && (
        <AddExtraCarsDiv>
          <ListItem.Root onClick={() => setShowExtraCars(true)}>
            <AddExtraCarsContentButton>
              <Button $hierarchy="secondary" $withoutColor>{intl.formatMessage({id: 'checkout_steps_ancillaries_car_rental_filtering_extra_cars_add_button'})}</Button>
            </AddExtraCarsContentButton>
          </ListItem.Root>
        </AddExtraCarsDiv>

      )}

      <Sheet modal open={isShowingExtraCars} >
        <SheetPortal>
          <SheetOverlay onClick={() => setShowExtraCars(false)}/>
          <StyledSheetContent $side="bottom">
            <SheetHeader>
              <SheetClose onClick={() =>setShowExtraCars(false)}>{intl.formatMessage({id: 'close'})}</SheetClose>
            </SheetHeader>
            <FilterableCarsAvailable />
          </StyledSheetContent>
        </SheetPortal>
      </Sheet>
    </SpaceBetween>
  );
}


export const AddExtraCarsDiv = styled.div`
  padding-top: ${space('primitives_space_12')};
  border-top: 2px solid ${tok('primitives_color_neutral_150')};
`;

const StyledSheetContent = styled(SheetContent)`
  background-color: ${tok('semantics_backgrounds_tinted_background_color')};
  ${SheetContentWrapper}{
    padding: 0;
  }
`
const AddExtraCarsContentButton = styled(ListItem.Content)`
  align-items: center;
`
